// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__83UQq","success":"alert_success__E7ymE","error":"alert_error__ZL5kc","warning":"alert_warning___rYkV"};